import { useState, useEffect } from "react";
import api from "../api/api";

function Register() {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [areas,  setAreas]  = useState([]);

  const [name,     setName]     = useState("");
  const [phone,    setPhone]    = useState("");
  const [password, setPassword] = useState("");
  const [address,  setAddress]  = useState("");
  const [areaId,   setAreaId]   = useState("");
  const [email, setEmail] = useState("");

  const [error,   setError]   = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/public/states").then(res => setStates(res.data));
  }, []);

  const onStateChange = (id) => {
    setCities([]); setAreas([]); setAreaId("");
    if (id) api.get(`/public/cities/${id}`).then(res => setCities(res.data));
  };

  const onCityChange = (id) => {
    setAreas([]); setAreaId("");
    if (id) api.get(`/public/areas/${id}`).then(res => setAreas(res.data));
  };

  const register = async () => {
    if (!name || !email || !phone || !password || !areaId) {
      setError("Please fill all fields and select your area");
      return;
    }
    setError(""); setLoading(true);
    try {
      const res = await api.post("/auth/register", {
        name, email, phone, password, address, areaId
      });
      if (res.data.success) {
        setSuccess("Account created! Redirecting to login…");
        setTimeout(() => window.location.href = "/", 1800);
      } else {
        setError(res.data.message || "Registration failed");
      }
    } catch {
      setError("Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* ── LEFT PANEL ─────────────────────────────── */}
      <div className="login-left">
        <div style={{ fontSize: 36, marginBottom: 10 }}>📰</div>
        <div className="login-headline">
          Join the<br /><span>Press</span><br />Network
        </div>
        <div className="login-divider" />
        <div className="login-tagline">
          Subscribe to your favourite newspapers and get them
          delivered to your doorstep every morning.
        </div>
      </div>

      {/* ── RIGHT PANEL ────────────────────────────── */}
      <div className="login-right" style={{ overflowY: "auto" }}>
        <div className="login-form-title">Create account</div>
        <div className="login-form-sub">Register as a new subscriber</div>

        {error   && <div className="alert alert-error">⚠ {error}</div>}
        {success && <div className="alert alert-success">✓ {success}</div>}

        <div className="login-form">
          <div className="form-group">
            <label className="form-label">Full Name</label>
            <div className="input-with-icon">
              <span className="input-icon">👤</span>
              <input className="form-input" placeholder="Your full name"
                value={name} onChange={e => setName(e.target.value)} />
            </div>
          </div>

          <div className="form-group">
  <label className="form-label">Email Address</label>
  <div className="input-with-icon">
    <span className="input-icon">✉️</span>
    <input
      className="form-input"
      type="email"
      placeholder="your@email.com"
      value={email}
      onChange={e => setEmail(e.target.value)}
    />
  </div>
</div>

          <div className="form-group">
            <label className="form-label">Phone Number</label>
            <div className="input-with-icon">
              <span className="input-icon">📱</span>
              <input className="form-input" placeholder="10-digit mobile number"
                value={phone} onChange={e => setPhone(e.target.value)} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="input-with-icon">
              <span className="input-icon">🔒</span>
              <input className="form-input" type="password" placeholder="Choose a password"
                value={password} onChange={e => setPassword(e.target.value)} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Delivery Address</label>
            <div className="input-with-icon">
              <span className="input-icon">🏠</span>
              <input className="form-input" placeholder="House no, street, landmark"
                value={address} onChange={e => setAddress(e.target.value)} />
            </div>
          </div>

          {/* Location selects */}
          <div className="form-group">
            <label className="form-label">State</label>
            <select className="form-select"
              onChange={e => onStateChange(e.target.value)} defaultValue="">
              <option value="" disabled>Select State</option>
              {states.map(s => (
                <option key={s.stateId} value={s.stateId}>{s.name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">City</label>
            <select className="form-select"
              onChange={e => onCityChange(e.target.value)} defaultValue="">
              <option value="" disabled>Select City</option>
              {cities.map(c => (
                <option key={c.cityId} value={c.cityId}>{c.name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Area</label>
            <select className="form-select"
              value={areaId} onChange={e => setAreaId(e.target.value)}>
              <option value="" disabled>Select Area</option>
              {areas.map(a => (
                <option key={a.areaId} value={a.areaId}>{a.name}</option>
              ))}
            </select>
          </div>

          <button
            className="btn btn-gold btn-lg btn-block"
            onClick={register}
            disabled={loading}
            style={{ marginTop: 6 }}
          >
            {loading ? "Creating account…" : "Create Account →"}
          </button>
        </div>

        <div className="login-footer-text">
          Already have an account?{" "}
          <a href="/" className="text-link">Sign in</a>
        </div>
      </div>
    </div>
  );
}

export default Register;
